import template from './resetPassword.html';
import controller from './resetPassword.controller';
import './resetPassword.scss';

let resetPasswordComponent = {
  bindings: {},
  template,
  controller
};

export default resetPasswordComponent;



// WEBPACK FOOTER //
// ./client/app/components/resetPassword/resetPassword.component.js